module.exports = __webpack_public_path__ + "static/media/chery.11345e74.png";